import EntityChallengeAddNew from './EntityChallengeAddNew';

export default EntityChallengeAddNew;
